import ApprovalsContainer from './approvals.container';

export default ApprovalsContainer;
